export const environment = {
  production: true,
  host: 'https://visiondistributionsales.it/',
  baseApi: 'https://visiondistributionsales.it/api',
  cdnHost: 'https://visiondistributionsales.it/',
  hubUrl: 'https://visiondistributionsales.it/hubs/notifications',
  allowRegistration: false,
  environment: 'production'
};
